module.exports = __webpack_public_path__ + "img/11.97fa90a6.jpg";